import { View, Pressable, StyleSheet } from "react-native";

const MAX_WIDTH = 600;

export default function ContentWidth({ children, style }: { children: React.ReactNode; style?: any }) {
  return (
    <View style={[s.container, style]}>
      {children}
    </View>
  );
}

export function ModalContent({ children, style, onClose }: { children: React.ReactNode; style?: any; onClose?: () => void }) {
  return (
    <Pressable style={s.modalOverlay} onPress={onClose}>
      <Pressable style={[s.modalInner, style]} onPress={(e) => e.stopPropagation()}>
        {children}
      </Pressable>
    </Pressable>
  );
}

const s = StyleSheet.create({
  container: {
    width: "100%",
    maxWidth: MAX_WIDTH,
    alignSelf: "center",
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.4)",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  modalInner: {
    width: "100%",
    maxWidth: MAX_WIDTH,
  },
});

export { MAX_WIDTH };
